import styled from '@emotion/styled'
import { breakpoint, calcRem, metrics, ThemeMargins } from '../../__styling'
import { WidgetPlacementType } from './CareerOneJobsWidget'

export interface GridProps {
    verticalSpacing?: keyof ThemeMargins | undefined
    verticalGutters?: [keyof ThemeMargins, keyof ThemeMargins]
}

export const CareerOneJobsWidgetContainer = styled('div')<GridProps>(
    ({ verticalSpacing, verticalGutters, theme }) => ({
        marginLeft: 'auto',
        marginRight: 'auto',
        marginTop: verticalSpacing && calcRem(theme.margins[verticalSpacing]),
        marginBottom:
            verticalSpacing && calcRem(theme.margins[verticalSpacing]),
        paddingTop:
            verticalGutters &&
            calcRem(metrics.sevennews.margins[verticalGutters[0]]),
        paddingBottom:
            verticalGutters &&
            calcRem(metrics.sevennews.margins[verticalGutters[1]]),
    }),
)

export interface CareerOneJobsWidgetIFrameProps {
    type: WidgetPlacementType
    src: string
}

export const CareerOneJobsWidgetIFrame = styled(
    'iframe',
)<CareerOneJobsWidgetIFrameProps>(
    {
        width: '100%',
        border: 'none',
    },
    ({ type }) => ({
        display: type === 'mobile' ? 'block' : 'none',
        height: calcRem(250),
        width: calcRem(300),
        [breakpoint('sm')]: {
            display: type === 'tablet' ? 'block' : 'none',
            height: calcRem(250),
            width: calcRem(640),
        },
        [breakpoint('md')]: {
            display: type === 'desktop' ? 'block' : 'none',
            height: calcRem(600),
            width: calcRem(300),
        },
    }),
)
